import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import IBsList from './IbsList';
import { Breadcrumbs } from '../../../AbstractElements';


const BasicTables = () => {
    return (
        <Fragment>
            <Breadcrumbs title="IBs" mainTitle='' />
            <Container fluid={true}>
                <Row>
                    <IBsList />
                </Row>
            </Container>
        </Fragment>
    );
};

export default BasicTables;